import { Container } from '../../odie';

import { IScreen } from '../../odie/plugins/nav/IScreen';
import { TabScreenOptions } from '../../odie/plugins/nav/TabNav';

/*
    basic tab screen
*/
export class BasicTabScreen implements IScreen {
  // fields
  //-------------------------------------------------------------------------
  private readonly _root: Container;
  private _width: number;
  private _height: number;

  // properties
  //-------------------------------------------------------------------------
  public get view(): Container {
    return this._root;
  }

  public get width(): number {
    return this._width;
  }

  public get height(): number {
    return this._height;
  }

  // init
  //-------------------------------------------------------------------------
  constructor(options: TabScreenOptions) {
    const { width, height } = options;

    // set fields
    this._width = width;
    this._height = height;

    // create root container
    this._root = new Container();
    this._root.width = width;
    this._root.height = height;
  }
}
